import * as React from "react"

// eslint-disable-next-line import/no-default-export
export default function SvgVerticalAlignMiddle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M12 22a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11 21v-3.2l-.925.925A.92.92 0 0 1 9.4 19a.96.96 0 0 1-.7-.3.95.95 0 0 1-.275-.7q0-.425.275-.7l2.6-2.6q.15-.15.325-.213.175-.062.375-.062t.375.062a.9.9 0 0 1 .325.213l2.625 2.625A.92.92 0 0 1 15.6 18q0 .4-.3.7a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-.9-.9V21q0 .424-.287.712A.97.97 0 0 1 12 22m-7-9a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 12a.97.97 0 0 1 .287-.713A.97.97 0 0 1 5 11h14q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 19 13zm7-3.425a1.1 1.1 0 0 1-.375-.063.9.9 0 0 1-.325-.212L8.675 6.675A.92.92 0 0 1 8.4 6q0-.4.3-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l.9.9V3q0-.425.288-.713A.97.97 0 0 1 12 2a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 3v3.2l.925-.925A.92.92 0 0 1 14.6 5q.4 0 .7.3a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-2.6 2.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" />
    </svg>
  )
}
